import React, {useEffect, useState, useRef} from 'react';
import {Input} from "antd";
import {SearchOutlined} from "@ant-design/icons";
import {ExcelPrint, Pdf, PrintElem} from "../../../../components/functions/Print";
import print from "../../../../icons/print.png";
import {NavLink} from "react-router-dom";
import pdf from "../../../../icons/pdf.png";
import excel from "../../../../icons/excel.png";
import $ from 'jquery'
import axios from "axios";
import {useReactToPrint} from "react-to-print";
import { getEnv } from "../../../../lib/env";


function Soatlik({setLocations,setLabels,region,district,setData, data,selectedRowKeys,setSelectedRowKeys}) {
    const conponentPDF= useRef();
    const [date, setDate] = useState(new Date().toISOString().slice(0, 10))
    const [ldate, setLdate] = useState(date)
    useEffect(() => {
        const fetchData = async () => {
            const res = await axios.get(
                `${getEnv('REACT_APP_BASE_URL')}/v1/district/proxy/soatlik?sana=${date}&region=${region}&district=${district}`,
                {
                    headers: {
                        // O'zingizning tizimingizdagi token (masalan, localStorage'dan olingan)
                        'Authorization': 'Bearer ' + localStorage.getItem('sw_user_token') 
                    }
                }
            );

            if (res && res.data) {
            setData(res.data.d);
            setLocations(res.data.l);
            }
        }
        fetchData();
        setLabels([0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23])
    }, [date])

    const chiz = (index) => {
        removeChecked()
        let v = $('tr.tr'+index+' input')
        let checked = v[0].checked;
        v[0].checked = !checked
        if(!checked){
            $('tr.tr'+index).addClass('active')
        }else{
            $('tr.tr'+index).removeClass('active')
        }
        setSelectedRowKeys(index)
    }
    const removeChecked = () => {
        if(selectedRowKeys !== '') {
            $('tr.tr'+selectedRowKeys+' input')[0].checked = false
            $('tr.tr'+selectedRowKeys).removeClass('active')
        }
    }
    const setSearchHandler = (text) => {
        $('tbody tr').each(function(){
            if ($(this).children('.fix-with')[0].innerText.toUpperCase().indexOf(text.toUpperCase()) > -1) {
                $(this)[0].style.display = "";
            } else {
                $(this)[0].style.display = "none";
            }
        })
    }
    const generatePDF= useReactToPrint({
        content: ()=>conponentPDF.current,
        documentTitle:"Userdata",
        onAfterPrint:()=>alert("Data saved in PDF")
    });
    useEffect(() => {
        if(selectedRowKeys!=''){
            chiz(selectedRowKeys)
        }
    }, [selectedRowKeys])
    return (
        <div className="table-box">
            <div className="table-content-top">
                <div className="table-top-left">
                    <Input
                        prefix={<SearchOutlined className="site-form-item-icon" />}
                        placeholder="Search"
                        onChange={e=>setSearchHandler(e.target.value)}
                    />
                </div>
                <ul className="table-top-right">
                    <input type="date" className="form-control form-control-sm" value={ldate}
                           onChange={e => setLdate(e.target.value)}/>
                    &nbsp;&nbsp;&nbsp;
                    <button className="btn btn-outline-primary btn-sm" onClick={() => setDate(ldate)}>Ok</button>

                    <li>
                        <button className="btn p-0" onClick={() => generatePDF()}>
                            <img src={print} alt="404"/>
                        </button>
                    </li>
                    <li>
                        <button  onClick={() => Pdf('tblData')} className="btn p-0">
                            <img src={pdf} alt="404"/>
                        </button>
                    </li>
                    <li>
                        <button className="btn p-0" onClick={()=>ExcelPrint("Aqlli suv soatlik", date, "tblData")}>
                            <img src={excel} alt="404"/>
                        </button>
                    </li>
                </ul>
            </div>
            <div id="content">
                <div id="tableFlexible" style={{height:(selectedRowKeys==='')?'80vh':'39vh'}}>
                    <div ref={conponentPDF} style={{width:'100%'}}>
                    <table id="tblData" className="table table-bordered table-style fixedHeader">
                        <thead className="">
                        <tr>
                            <th rowSpan={2} className="sticky st1">o</th>
                            <th rowSpan={2} className="sticky" style={{left:"31px"}}>T/R</th>
                            <th rowSpan={2} className="sticky" style={{left:"72px"}}>Stantsiya nomi</th>
                            <th colSpan={24}>{date}</th>
                        </tr>
                        <tr>
                            {
                                Array(24).fill().map((p,i)=>{
                                    return <th key={i}>{i<9?'0'+(i+1):i+1}</th>
                                })
                            }
                        </tr>
                        </thead>
                        <tbody>
                        {
                            data.length > 0 ?
                                data.map((d,index)=>{
                                    return <tr key={index} onClick={() => chiz(index)} className={"tr"+index}>
                                        <td className="sticky st1">
                                            <input type="checkbox"/>
                                        </td>
                                        <td className="sticky"  style={{left:"31px"}}>{index+1}</td>
                                        <td className="text-start sticky fix-with"  style={{left:"72px"}}>{d.name}</td>
                                        {
                                            Array(24).fill().map((p,i)=>{
                                                return <td key={i}>{d.data?d.data[i]?d.data[i].volume:'':''}</td>
                                            })
                                        }
                                    </tr>
                                })
                                :null
                            }
                        </tbody>
                    </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Soatlik;